module.exports = __webpack_public_path__ + "media/images/pdf-icon-8d3753daac3bfe3ce973e850378c3f0c.png";